module.exports = __webpack_public_path__ + "img/product28803b.3b5be6a9.png";